export const API_KEYS_COLUMNS: { header: string; key: string }[] = [
  {
    header: 'Name',
    key: 'name',
  },
  {
    header: 'Key',
    key: 'key',
  },
  {
    header: 'Created',
    key: 'created',
  },
  {
    header: '',
    key: 'actions',
  },
];

export const API_USAGES_COLUMNS: { header: string; key: string }[] = [
  // {
  //   header: 'Key',
  //   key: 'key',
  // },
  // {
  //   header: 'Input Tokens',
  //   key: 'input_tokens',
  // },
  // {
  //   header: 'Output Tokens',
  //   key: 'output_tokens',
  // },
  // {
  //   header: 'Input Cost',
  //   key: 'input_cost',
  // },
  // {
  //   header: 'Output Cost',
  //   key: 'output_cost',
  // },
  {
    header: 'Date/Time',
    key: 'date',
  },
  {
    header: 'Total Cost',
    key: 'total_cost',
  },
  {
    header: 'Model/Task',
    key: 'model_task',
  },
];
